import { Component, OnInit, Injector } from '@angular/core';
import { PurchaseReportServiceProxy, 
        AgedPayableDetailReportDto, AgedPayableReportInput, 
        CommonLookupServiceProxy,
        DropDownLookupDto,
 } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from '@node_modules/@types/luxon';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { AppConsts } from '@shared/AppConsts';

@Component({
  selector: 'app-aged-payable-details',
  standalone: false,
  templateUrl: './aged-payable-details.component.html',
  styles: ``
})


export class AgedPayableDetailsComponent extends AppComponentBase implements OnInit {

  loading = false;
  locations: DropDownLookupDto[] = [];
  selectedLocations: any[] = [];
  purchaseReportOutput: AgedPayableDetailReportDto;
  vendors: DropDownLookupDto[];
  selectedVendors: any[] = [];
  vendorId : 0;
  filterDate: Date = new Date();
  dateFormat = AppConsts.dateFormat;

  constructor(
            injector: Injector,
        private lookupService: CommonLookupServiceProxy,
        private purchaseReportService: PurchaseReportServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _fileDownloadService: FileDownloadService,
      
    ){
      super(injector);
    }

  ngOnInit(): void {
    this.loadLocations();
    this.initializeDateRange();
    this.getReportDetails();
  }

  loadLocations()
  {
      this._commonLookupServiceProxy.getAllVendorForTableDropdown().subscribe((result) => {
          this.vendors = result;
      });

  }

  initializeDateRange() {
    this.filterDate = new Date();
  }

  getReportDetails() {

    const selVendors = this.selectedVendors.length
      ? this.selectedVendors
      : [];

    this.loading = true;

    let inputPurchaseReport = new AgedPayableReportInput();
    console.log(this.filterDate);
    const filterDateStr = moment(this.filterDate).format('YYYY-MM-DD');
    
    inputPurchaseReport.filterDate = filterDateStr as any;
    inputPurchaseReport.locationId = this.appSession.user.locationId;
    inputPurchaseReport.vendorIds = selVendors as any;

    this.purchaseReportService.getAgedPayableDetails(inputPurchaseReport)
    .subscribe(result => {
      this.purchaseReportOutput = result;
      console.log(result);
      //this.netProfitAmounts = result[0]?.netProfitAmounts || [];
      this.loading = false;
    });
  }

getReportDetailsExcel()
{

    const selVendors = this.selectedVendors.length
      ? this.selectedVendors
      : [];

    this.loading = true;

    let inputPurchaseReport = new AgedPayableReportInput();
    console.log(this.filterDate);
    const filterDateStr = moment(this.filterDate).format('YYYY-MM-DD');
    
    inputPurchaseReport.filterDate = filterDateStr as any;
    inputPurchaseReport.locationId = this.appSession.user.locationId;
    inputPurchaseReport.vendorIds = selVendors as any;
    
    this.purchaseReportService.getAgedPayableDetailsExportExcel(inputPurchaseReport)
    .subscribe(result => {
      this._fileDownloadService.downloadTempFile(result);
      this.loading = false;
    });

}

}